import { api } from '@services';

import Equipment, {
  IEquipment,
  IEquipmentApiModel,
} from '@models/Equipment.model';

interface IGetUpdateAffectedItems {
  updateId: string;
}

const getUpdateAffectedItems = async ({
  updateId,
}: IGetUpdateAffectedItems): Promise<IEquipment[]> => {
  const { data: equipments } = await api.get<IEquipmentApiModel[]>(
    `/updates/${updateId}/affectedItems`,
  );

  return Equipment.arrayFromApiModel(equipments);
};

export { getUpdateAffectedItems };
